import React from 'react';
import { visuallyHidden } from '@noths/polaris-client-styles';

import { StarRating } from 'src/components/molecules/StarRating';
import { StarRating as StarRatingType } from 'src/types/product';
import { OVERALL_RATING_HEADER } from '../constants/copy';
import * as styles from './styles';

export interface OverallRatingProps {
  productRating: StarRatingType;
  numberOfReviews: number;
}

export const OverallRating = ({ numberOfReviews, productRating }: OverallRatingProps) => {
  if (!productRating) {
    return null;
  }

  return (
    <div css={styles.overallRatingContainer}>
      <h2 css={styles.ratingHeader}>{OVERALL_RATING_HEADER}</h2>
      <p css={visuallyHidden}>{productRating} out of 5</p>
      <p css={styles.overallRatingLabel} aria-hidden="true">
        <span data-testid="rating" css={styles.overallRating}>
          {productRating}
        </span>{' '}
        / 5
      </p>
      <StarRating
        productRating={productRating}
        numberOfReviews={numberOfReviews}
        numberOfReviewsCopy={`${numberOfReviews} Reviews`}
        accessibleLabel={`${productRating} out of 5`}
      />
    </div>
  );
};
